import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Youtube, Facebook, Video } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#003B5C] text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-4">
            <img
              src="https://customer-assets-v7afamib.emergentagent.net/job_ebenezer-ghana-sda/artifacts/861qgsvb_garland-ebenezer-ghanaian-seventh-day-adventist-church-logo%20%281%29.webp"
              alt="Garland Ebenezer Ghanaian Seventh-day Adventist Church"
              data-testid="footer-logo-image"
              className="h-16 w-auto object-contain mb-6"
              style={{ filter: "brightness(0) invert(1)" }}
            />
            <p className="text-white/70 text-sm leading-relaxed">
              A community of believers committed to worship, prayer, Bible study, and serving
              others. There is a place for you here.
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-display text-xs uppercase tracking-[0.2em] text-[#D4A437] font-bold mb-5">
              Visit
            </h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex gap-3">
                <MapPin size={16} className="mt-0.5 text-[#D4A437] flex-shrink-0" />
                <span>271 Walton St,<br />Richardson, TX 75081<br /><span className="text-white/60 italic">Please park at Lot C</span></span>
              </li>
              <li className="flex gap-3">
                <Phone size={16} className="mt-0.5 text-[#D4A437] flex-shrink-0" />
                <a href="tel:6825647119" data-testid="footer-phone" className="hover:text-white">682-564-7119</a>
              </li>
              <li className="flex gap-3">
                <Mail size={16} className="mt-0.5 text-[#D4A437] flex-shrink-0" />
                <a href="mailto:egsda01@gmail.com" data-testid="footer-email" className="hover:text-white break-all">egsda01@gmail.com</a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-display text-xs uppercase tracking-[0.2em] text-[#D4A437] font-bold mb-5">
              Service Times
            </h4>
            <ul className="space-y-2 text-sm text-white/80">
              <li><span className="font-semibold text-white">Saturday</span></li>
              <li>Sabbath School<br /><span className="text-white/60">9:30 AM</span></li>
              <li>Divine Worship<br /><span className="text-white/60">11:15 AM</span></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-display text-xs uppercase tracking-[0.2em] text-[#D4A437] font-bold mb-5">
              Connect
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-white/80 hover:text-white">About Us</Link></li>
              <li><Link to="/sermons" className="text-white/80 hover:text-white">Sermons</Link></li>
              <li><Link to="/events" className="text-white/80 hover:text-white">Events</Link></li>
              <li><Link to="/ministries" className="text-white/80 hover:text-white">Ministries</Link></li>
              <li><Link to="/give" className="text-white/80 hover:text-white">Give</Link></li>
            </ul>

            <div className="flex items-center gap-3 mt-6">
              <a href="https://www.facebook.com/gebenezersda" target="_blank" rel="noopener noreferrer" data-testid="footer-social-facebook" aria-label="Facebook" className="w-9 h-9 rounded-sm border border-white/20 flex items-center justify-center hover:bg-[#D4A437] hover:border-[#D4A437] transition-colors">
                <Facebook size={16} />
              </a>
              <a href="https://www.youtube.com/@garlandebenezerghanaiansda" target="_blank" rel="noopener noreferrer" data-testid="footer-social-youtube" aria-label="YouTube" className="w-9 h-9 rounded-sm border border-white/20 flex items-center justify-center hover:bg-[#D4A437] hover:border-[#D4A437] transition-colors">
                <Youtube size={16} />
              </a>
              <a href="https://us02web.zoom.us/j/86107004821?pwd=OE9hcjJXRTllSkdPQXlQcGhLU1J2UT09" target="_blank" rel="noopener noreferrer" data-testid="footer-social-zoom" aria-label="Zoom" className="w-9 h-9 rounded-sm border border-white/20 flex items-center justify-center hover:bg-[#D4A437] hover:border-[#D4A437] transition-colors">
                <Video size={16} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10">
          <div className="bg-white/5 border border-white/10 rounded-sm p-5 text-sm">
            <p className="font-semibold text-[#D4A437] mb-2 font-display tracking-wide uppercase text-xs">Join Worship Online via Zoom</p>
            <div className="text-white/80 flex flex-col sm:flex-row sm:gap-6 gap-1">
              <span>Meeting ID: <span className="text-white font-mono">861 0700 4821</span></span>
              <span>Passcode: <span className="text-white font-mono">2022</span></span>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Garland Ebenezer Ghanaian Seventh-day Adventist Church. All rights reserved.</p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white/80 transition-colors">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};
